import { down } from 'styled-breakpoints'
import styled from 'styled-components'
import ripple from '../../styles/animations/ripple'
import { darken } from 'polished'

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 25px;
  min-height: 52px;
  box-shadow: 4px 0px 5px 0px rgba(0, 0, 0, 0.36);
  background-color: ${({ theme }) => theme.colors.header};
  z-index: 100;
  transition: padding-left 0.5s cubic-bezier(0.82, 0.085, 0.395, 0.895);
  overflow: hidden;
  ${down('md')} {
    margin-left: 0px;
    padding-left: 25px;
    height: auto;
  }
`

export const ButtonRound = styled.div`
  ${ripple}
  cursor: pointer;
  width: 30px;
  height: 30px;
  min-width: 30px;
  min-height: 30px;
  background-color: ${({ theme }) => theme.colors.primary};
  border-radius: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const Content = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  height: 100%;
  width: 100%;
  padding: 8px 0px;
  justify-content: space-between;
  gap: 15px;
  svg {
    cursor: pointer;
  }
  img {
    ${ripple}
    cursor: pointer;
    width: 25px;
    height: 25px;
  }
`

export const TitleHeader = styled.label`
  color: ${({ theme }) => theme.colors.label};
`

export const Line = styled.div`
  width: 2px;
  background-color: ${({ theme }) => darken(-0.2, theme.colors.primary)};
  height: 100%;
`
